<template>
  <div class="params">
    <div class="tale">
      <div class="box_warpNet">
        <p>{{ dataobjs.jicunqicanshu }}</p>
        <el-button
          size="small"
          plain
          @click="clckAd"
          v-if="roletypeValue == 0 && isagree == 0"
          >{{ dataobjs.xinzengtongdao }}</el-button
        >
        <el-button
          size="small"
          plain
          @click="clckAdPreams(1)"
          v-if="flynames == 0"
          >{{ dataobjs.tongdaocanshushezhi }}</el-button
        >
        <!-- <el-button size="small" plain  @click="clckAdPreamsTwo(2)">通道参数</el-button> -->
      </div>
      <!-- :expand-row-keys="expands"   :row-key="getRowKeys" -->

      <el-table
        class="tablengt"
        :data="tableDataOut"
        style="width: 100%"
        :expand-row-keys="expands"
        :row-key="getRowKeys"
        :header-cell-style="{
          background: '#CCCCCC',
          color: '#F7F7F7',
          fontSize: '14px',
        }"
        :row-class-name="tableRowClassName"
        :highlight-current-row="false"
      >
        <!-- <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              :header-cell-style="{background:'#eef1f6',co2lor:'#60666',fontWeight:'normal'}"
              :data="props.row.channelinfo"
              style="width: 100%"
            >
            
              <el-table-column :label="dataobjs.tongdaohao" align="center" fixed="left">
                <template slot-scope="scope">
                  <span>{{ scope.row.channelid }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="dataobjs.tongdaoming" align="center" fixed>
                <template slot-scope="scope">
                  <span>{{ scope.row.unittype}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="dataobjs.tongdaomingyingwen" align="center" fixed>
                <template slot-scope="scope">
                  <span>{{ scope.row.unittype_en }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="dataobjs.tongdaobieming" align="center" fixed>
                <template slot-scope="scope">
                  <span>{{ scope.row.channelname }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="dataobjs.shangxianzhi" align="center" fixed>
                <template slot-scope="scope">
                  <span>{{ scope.row.upperlimit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="dataobjs.xiaxianzhi"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.lowerlimit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="dataobjs.shangxianbaojingzhi"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.upperlimit_alarm }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="dataobjs.xiaxianbaojingzhi"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.lowerlimit_alarm }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="dataobjs.beizhu"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column> -->

        <el-table-column
          :label="dataobjs.jiqunqiid"
          align="center"
          prop="deviceid"
          width="90"
        ></el-table-column>
        <el-table-column
          prop="startaddress"
          :label="dataobjs.qishidizhi"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="number"
          :label="dataobjs.jicunqichangdu"
          width="100"
        ></el-table-column>

        <el-table-column :label="dataobjs.caozuo" align="center" width="150">
          <!--   @click="editFrom(row)" -->
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              @click="editFrom(row)"
              round
              icon="el-icon-edit"
              type="text"
              >{{ dataobjs.xiugai }}</el-button
            >
            <!--    @click="deleData(row)" -->
            <el-button
              size="mini"
              type="text"
              @click="deleData(row)"
              v-if="flynames == 0"
              icon="el-icon-delete"
              round
              >{{ dataobjs.shanchu }}</el-button
            >
          </template>
        </el-table-column>

        <el-table-column>
          <template slot-scope="props">
            <el-table
              :header-cell-style="{
                background: '#eef1f6',
                co2lor: '#60666',
                fontWeight: 'normal',
              }"
              :data="props.row.channelinfo"
              style="width: 100%"
            >
              <el-table-column
                :label="dataobjs.tongdaohao"
                align="center"
                fixed="rigth"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.channelid }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="dataobjs.tongdaoming" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.unittype }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="dataobjs.tongdaomingyingwen"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.unittype_en }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="dataobjs.tongdaobieming" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.channelname }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="dataobjs.shangxianzhi" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.upperlimit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="dataobjs.xiaxianzhi"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.lowerlimit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="dataobjs.shangxianbaojingzhi"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.upperlimit_alarm }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="dataobjs.xiaxianbaojingzhi"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.lowerlimit_alarm }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="dataobjs.beizhu"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>

              <el-table-column
                :label="dataobjs.waibujiekoubianma"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.out_code }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div></div> -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisibleDetile"
      :modal="false"
      width="70%"
      center
      :close-on-click-modal="false"
    >
      <div class="box_warpNet">
        <p style="height:20px">{{ dataobjs.jicunqicanshu }}</p>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="fromData"
      >
        <el-form-item
          :label="dataobjs.jiqunqiid"
          prop="startaddress"
          style="width:31%"
          v-if="!flyShow"
        >
          <el-input
            :disabled="flynames != 0"
            v-model="ruleForm.deviceid"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="dataobjs.qishidizhi"
          prop="startaddress"
          style="width:31%"
        >
          <el-input
            :disabled="flynames != 0"
            v-model="ruleForm.startaddress"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="dataobjs.jicunqichangdu"
          prop="number"
          style="width:31%"
        >
          <div class="input btnes">
            <el-input v-model="ruleForm.number" :disabled="!flyShow"></el-input>
            <el-button
              type="primary"
              style="margin: 4px 5px;"
              @click="dialogVisibleaddlist"
              v-if="flyShow"
              >{{ dataobjs.queding }}</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <div class="box_warpNet">
        <p style="height:20px">{{ dataobjs.tongdaocanshu }}</p>
      </div>
      <div class="tableNet">
        <el-table :data="tableData" border @row-dblclick="dbclick">
          <!-- <el-table-column label="操作" width="80" align="center" v-if="!!flyShow" > -->
          <!-- <template slot-scope="{row}"> -->
          <!-- <el-form :model="scope.row">
                <el-form-item size="mini">
                  <el-input
                    v-if="scope.row.isOK"
                    v-model="scope.row.channelid"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.channelid }}</span>
                </el-form-item>
          </el-form>-->
          <!-- <el-button size="mini" @click="selectList(row)" round type="success" v-if="flyShow">选择</el-button> -->
          <!-- </template> -->
          <!-- </el-table-column> -->
          <el-table-column
            :label="dataobjs.tongdaohao"
            align="center"
            fixed="left"
          >
            <template slot-scope="scope">
              <el-form :model="scope.row">
                <el-form-item size="mini">
                  <el-input
                    v-if="flynames == 0"
                    v-model="scope.row.channelid"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.channelid }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>

          <el-table-column
            prop="upperlimit"
            :label="dataobjs.tongdaoming"
            align="center"
          >
            <template slot-scope="scope">
              <el-form :model="scope.row">
                <el-form-item size="mini">
                  <el-input
                    v-if="!scope.row.isOK"
                    v-model="scope.row.unittype"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.unittype }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>

          <el-table-column
            prop="channelname"
            :label="dataobjs.tongdaobieming"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-form :model="scope.row">
                <el-form-item size="mini">
                  <el-input
                    v-if="scope.row.isOK"
                    v-model="scope.row.channelname"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.channelname }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>

          <el-table-column
            prop="unittype_en"
            :label="dataobjs.tongdaomingyingwen"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <el-form :model="scope.row">
                <el-form-item size="mini">
                  <el-input
                    v-if="!scope.row.isOK"
                    v-model="scope.row.unittype_en"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.unittype_en }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            prop="upperlimit"
            :label="dataobjs.shangxianzhi"
            align="center"
          >
            <template slot-scope="scope">
              <el-form :model="scope.row">
                <el-form-item size="mini">
                  <el-input
                    v-if="scope.row.isOK"
                    v-model="scope.row.upperlimit"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.upperlimit }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>

          <el-table-column
            prop="address"
            :label="dataobjs.xiaxianzhi"
            align="center"
          >
            <template slot-scope="scope">
              <el-form :model="scope.row">
                <el-form-item size="mini">
                  <el-input
                    v-if="scope.row.isOK"
                    v-model="scope.row.lowerlimit"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.lowerlimit }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            :label="dataobjs.shangxianbaojingzhi"
            align="center"
          >
            <template slot-scope="scope">
              <el-form :model="scope.row">
                <el-form-item size="mini">
                  <el-input
                    v-if="scope.row.isOK"
                    v-model="scope.row.upperlimit_alarm"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.upperlimit_alarm }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>

          <el-table-column
            prop="address"
            :label="dataobjs.xiaxianbaojingzhi"
            align="center"
          >
            <template slot-scope="scope">
              <el-form :model="scope.row">
                <el-form-item size="mini" style="text-align: center;">
                  <el-input
                    v-if="scope.row.isOK"
                    v-model="scope.row.lowerlimit_alarm"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.lowerlimit_alarm }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            :label="dataobjs.beizhu"
            align="center"
          >
            <template slot-scope="scope">
              <el-form :model="scope.row">
                <el-form-item size="mini" style="text-align: center;">
                  <el-input
                    v-if="scope.row.isOK"
                    v-model="scope.row.remark"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.remark }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>

          <el-table-column
            :label="dataobjs.waibujiekoubianma"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-form :model="scope.row">
                <el-form-item size="mini" style="text-align: center;">
                  <el-input
                    v-if="scope.row.isOK"
                    v-model="scope.row.out_code"
                    style="width:100%;hight:100%"
                  ></el-input>
                  <span v-else>{{ scope.row.out_code }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            :label="dataobjs.caozuo"
            align="center"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <!--  v-if="flyShow" -->
              <el-button
                size="mini"
                @click="selectList(row)"
                round
                type="success"
                v-if="flyShow"
                >{{ dataobjs.xuanze }}</el-button
              >
              <el-button
                size="mini"
                @click="Detleis(row)"
                round
                type="text"
                v-if="!flyShow"
                :disabled="flynames != 0"
                >{{ dataobjs.xuanze }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer list btenEtiel">
        <el-button @click="dialogVisiblecs('ruleForm')">{{
          dataobjs.quxiao
        }}</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          v-if="flyShow"
          >{{ dataobjs.baocun }}</el-button
        >
        <el-button
          type="primary"
          @click="submitFormEdit('ruleForm')"
          v-if="!flyShow"
          >{{ dataobjs.baocun }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 下拉框 弹框 -->
    <div class="el-dialogLIST">
      <el-dialog
        title="选择传感单元"
        :visible.sync="dialogVisibleEdit"
        width="20%"
        :show-close="false"
        :modal="false"
        :before-close="handleClose"
      >
        <el-select
          v-if="flyShow"
          style="width:100%"
          v-model="valueselect"
          filterable
          placeholder="请选择"
          @change="mylist"
          :filter-method="dataFilter"
        >
          <el-option
            v-for="item in selectValu"
            :key="item.id"
            :label="item.unittype"
            :value="item.id"
          ></el-option>
        </el-select>

        <!-- 修改 -->
        <el-select
          v-if="!flyShow"
          style="width:100%"
          v-model="valueselectTo"
          filterable
          placeholder="请选择"
          @change="mylistTo"
          :filter-method="dataFilter"
        >
          <el-option
            v-for="item in selectValu"
            :key="item.uuid"
            :label="item.unittype"
            :value="item.uuid"
          ></el-option>
        </el-select>

        <!-- <el-select v-model="value" placeholder="请选择" filterable :filter-method="dataFilter">
      <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>-->
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleHide">取 消</el-button>
          <el-button type="primary" @click="confinglist">确 定</el-button>
        </span>-->
      </el-dialog>
      {{ gitWei }}
    </div>
  </div>
</template>

<script>
import {
  channelAdd,
  listwgtd,
  PropertyData,
  getdataCs,
  listCgDy,
  listCgDySearch,
  channelAddEditWG,
  listwgtduUID,
  dealerDelete,
  hunHeData,
  SheZhiData,
  lang_fend,
} from "@/network/index.js";
export default {
  props: {
    gatewayuuid: {
      type: String,
      default: "",
    },
    flyuuid: {
      type: String,
      default: "",
    },
    flynames: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // ruleFormDeit:{
      //   unittype_en:'',
      //   channelname:'',
      //   upperlimit:'',
      //   lowerlimit:'',
      //   upperlimit_alarm:'',
      //   lowerlimit_alarm:'',
      //   sensingunit_uuid:'',
      //   uuid:'',
      //   remark:''

      // },
      editUUid: "",
      valueselectTo: "",
      valueUnid: "",
      title: "新增参数",
      expands: [],
      tableDataOut: [],
      tableDataPramies: [],
      selectValu: [],
      dialogVisibleEdit: false, //选择
      dialogVisibleDetile: false,
      tableData: [],
      valueselect: "",
      flyShow: true,
      ruleForm: {
        startaddress: "0000",
        number: "0001",
        deviceid: "",
      },
      property_uuid: "",
      rules: {
        startaddress: [
          { required: true, message: "请输入起始地址", trigger: "blur" },
          { min: 4, max: 4, message: "长度在 4个字符", trigger: "blur" },
        ],
        number: [
          { required: true, message: "请输入寄存器长度", trigger: "blur" },
        ],
      },
      index_I: "",
      channelid: "",
      counts: 0,
      lengtUid: "",
      lang_file: sessionStorage.getItem("lang_file"),
      isagree: sessionStorage.getItem("isagree"),
      roletypeValue: sessionStorage.getItem("roletypeValue"),
      dataobjs: {},
      flyEied: true,
      property_uuid: "",
      channelidTdaohao: "",
    };
  },
  created() {},
  computed: {
    gitWei() {
      if (this.flyuuid != "") {
        this.gatewayuuid = this.gatewayuuid;
        // this.getdataCs();
        // this.listwgtd();
        this.hunHeData();
      }
      //  return
    },
  },
  mounted() {
    // this.tongDao()
    this.listCgDy();
    this.lang_fend();
  },
  methods: {
    //修改的下落框
    mylistTo() {
      let valueName = {};
      this.selectValu.forEach((item) => {
        if (item.uuid == this.valueselectTo) {
          // console.log(item.uuid);
          // this.valueselectTo = item.uuid
          valueName = {
            id: item.id,
            uuid: this.editUUid,
            sensingunit_uuid: item.uuid,
            upperlimit: item.upperlimit,
            lowerlimit: item.lowerlimit,
            upperlimit_alarm:
              item.upperlimit_alarm == undefined ? null : item.upperlimit_alarm,
            lowerlimit_alarm:
              item.lowerlimit_alarm == undefined ? null : item.lowerlimit_alarm,
            isOK: true,
            channelid: this.channelidTdaohao,
            unittype: item.unittype,
            unittype_en: item.unittype_en,
            remark: item.remark == undefined ? "" : item.remark,
            channelname: item.channelname == undefined ? "" : item.channelname,
            out_code: item.out_code == undefined ? "" : item.out_code,
          };
          // item.sensingunit_uuid = item.uuid
          // item.isOK = true
          //  valueName = item; //拿到选中的值
        }
      });

      let channelinfo = [];
      this.tableData.forEach((item, index) => {
        if (item.uuid == this.editUUid) {
          item = valueName;
        }
        this.$set(this.tableData, index, item);

        // channelinfo.push(itemI)

        // item.channelinfo.forEach((itemI,index)=>{

        // })
      });
      this.valueselectTo = "";
      this.dialogVisibleEdit = false;

      // console.log(this.tableData);
      // console.log(channelinfo);
      // let arrr = []
      //  this.tableDataOut.forEach((item,index)=>{

      //     item.channelinfo = channelinfo
      //       // console.log(item,"11");
      //       // arrr.push(item)

      //  })
      //  this.tableDataOut = []
      //  this.tableDataOut.push(...arrr)

      //  console.log(this.tableDataOut);
    },
    async lang_fend() {
      let page = "gateway_channel_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      console.log(data);

      this.$emit("myPremnt", data);
      this.dataobjs = data;
    },
    clckAdPreams(type) {
      this.$confirm(`${this.dataobjs.tishixinxi}`, `${this.dataobjs.tishi}`, {
        confirmButtonText: `${this.dataobjs.queding}`,
        cancelButtonText: `${this.dataobjs.quxiao}`,
        closeOnClickModal: false,
        type: "success",
      })
        .then(async () => {
          const { code, data, msg } = await SheZhiData(type, this.gatewayuuid);
          // console.log(data);

          this.$message({
            type: "success",
            message: msg,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.dataobjs.yiquxiao}`,
          });
        });
    },
    //  clckAdPreamsTwo(type){
    //    this.$confirm('请确定是否设置该网关的网关通道?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'success'
    //     }).then( async() => {
    //       const {code,data,msg} = await SheZhiData(type,  this.gatewayuuid)
    //       console.log(data);

    //       this.$message({
    //         type: 'success',
    //         message:msg
    //       });
    //     }).catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消'
    //       });
    //     });
    // },
    getRowKeys(row) {
      return row.id;
    },
    // 删除
    deleData(e) {
      let { uuid } = e;
      this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let tablename = "tb_gateway_property";
          const { code, msg } = await dealerDelete(uuid, tablename);
          if (code) {
            // this.getdataCs();
            // this.listwgtd();
            this.hunHeData();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 修改(弹框)
    async Detleis(e) {
      // console.log(e);
      // console.log(e);
      this.channelidTdaohao = e.channelid;

      // if(this.flyEied){

      this.editUUid = e.uuid;
      this.selectValu.forEach((item) => {
        if (item.uuid == e.sensingunit_uuid) {
          this.valueselectTo = item.uuid;
        }
      });
      // }
      // this.flyEied =false
      this.dialogVisibleEdit = true;
    },
    // async Detleis(e) {
    //   this.title = '修改参数'
    //   const { code, data, msg } = await channelAddEditWG(e);
    //   console.log(data);
    //   if (code) {
    //          this.listwgtd();
    //     this.hunHeData()
    //     this.$message.success(msg);

    //   } else {
    //     this.$message.error(msg);
    //   }
    // },
    // // 修改
    editFrom(e) {
      this.property_uuid = e.uuid;
      this.ruleForm = e;
      this.lengtUid = e.uuid;
      this.listwgtduUID();
      // this.hunHeData()
      this.title = this.dataobjs.xiugai;
      this.flyShow = false;
      this.dialogVisibleDetile = true;
    },
    // 修改确定按钮
    //  async dialogVisibleConft() {
    //           let uuid = this.ruleFormDeit.uuid
    //           let objData = JSON.stringify(this.ruleFormDeit)
    //           const { code, data, msg } = await channelAddEditWG(uuid,objData)
    //           // console.log(data);

    //   },
    async listwgtd() {
      this.tableDataPramies = [];
      let pagenum = 1;
      let pagesize = 30;
      const { code, data, msg } = await listwgtd(
        this.gatewayuuid,
        pagenum,
        pagesize
      );
      // console.log(data,"---*****");

      if (data != "") {
        // this.tableDataPramies.push(...data.list);
        // this.counts = data.pagelist[0].allrow
      }
    },
    //寄存器的修改
    async listwgtduUID() {
      this.tableData = [];
      let pagenum = 1;
      let pagesize = 30;
      const { code, data, msg } = await listwgtduUID(
        this.lengtUid,
        pagenum,
        pagesize
      );
      // console.log(data,"---*****");

      if (data != "") {
        // console.log( this.tableDataPramies);
        let arr = [];
        data.list.forEach((item) => {
          item.isOK = true;
          arr.push(item);
        });
        this.tableData.push(...arr);
        // this.counts = data.pagelist[0].allrow
      }
    },
    handleClose(dom) {
      this.valueselect = "";
      this.listCgDy();
      dom();
    },
    //魔化查询
    async dataFilter(val) {
      let search = val;
      const { code, data } = await listCgDySearch(search);
      if (code) {
        this.selectValu = data;
      }
    },
    dbclick(row) {
      // row.isOK = !row.isOK;
    },
    // 下拉框
    mylist(e) {
      // console.log('22222222');

      // console.log( this.selectValu);
      // console.log(this.channelid);

      this.valueUnid = e;
      this.selectValu.forEach((item, index) => {
        if (item.id == e) {
          let objs = {
            id: this.index_I,
            sensingunit_uuid: item.uuid,
            upperlimit: item.upperlimit,
            lowerlimit: item.lowerlimit,
            upperlimit_alarm:
              item.upperlimit_alarm == undefined ? null : item.upperlimit_alarm,
            lowerlimit_alarm:
              item.lowerlimit_alarm == undefined ? null : item.lowerlimit_alarm,
            isOK: true,
            channelid: this.channelid,
            unittype: item.unittype,
            unittype_en: item.unittype_en,
            remark: item.remark == undefined ? "" : item.remark,
            channelname: item.channelname == undefined ? "" : item.channelname,
            out_code: item.out_code == undefined ? "" : item.out_code,
          };
          // console.log(this.index_I);
          this.dialogVisibleEdit = false;
          this.$set(this.tableData, this.index_I, objs);
          // this.tableData.push(objs[this.index_I])
        }
      });
      this.valueselect = "";
      this.listCgDy();
      //  console.log(this.tableData);
    },
    // 下拉框数据 selectValu
    async listCgDy() {
      const { code, data, msg } = await listCgDy();
      if (code) {
        this.selectValu = data;
      }
    },
    //选择通道(新增)
    selectList(e) {
      console.log(e);

      this.dialogVisibleEdit = true;
      // console.log(e.id);

      this.index_I = e.id;
      this.channelid = e.channelid;
    },
    dialogVisibleHide() {
      this.valueselect = "";
      this.listCgDy();
      this.dialogVisibleEdit = false;
    },
    //下拉框确定
    confinglist() {
      this.valueselect = "";
      this.listCgDy();
      this.dialogVisibleEdit = false;
    },
    // 寄存器长度确定
    dialogVisibleaddlist() {
      // console.log(this.ruleForm.startaddress.length);

      if (
        this.ruleForm.startaddress.length != 4 &&
        this.ruleForm.startaddress.length <= 5
      ) {
        this.$message.error("不能超过4个字符");
        return false;
      }
      let counts = Number(this.ruleForm.number);

      this.tableData = [];
      let nub = Number(this.counts); //后台的5
      console.log(nub);

      for (let i = 0; i < counts; i++) {
        // let unbs = i + 1;
        let unbs = nub + i + 1;
        this.tableData.push({ id: i, channelid: unbs });
      }
      // if (counts <= 0) {
      //   this.$message.error("不能小于0");
      // } else {

      // }
    },
    // 新增参数
    clckAd() {
      // this.$emit("myAddclick");
      // this.ruleForm.number = '0001'
      // this.ruleForm.startaddress ='0000'
      this.title = this.dataobjs.xinzengcanshu;
      this.flyShow = true;
      this.tableData = []; //情况弹出框的table表格
      // this.ruleForm={}
      this.dialogVisibleDetile = true;
    },
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "success-row1";
      } else {
        return "success-row1";
      }
    },
    // table列表寄存器列表
    async hunHeData() {
      // alert('111')
      const { code, data } = await hunHeData(this.gatewayuuid);
      this.tableDataOut = data;
      let dataInfo = data;
      data.forEach((item) => {
        //打开折叠
        this.expands.push(item.id);
      });
    },
    async getdataCs() {
      let pagenum = 1;
      let pagesize = 30;
      let gateway_uuid = this.gatewayuuid;
      const { code, data } = await getdataCs(gateway_uuid, pagenum, pagesize);
      // console.log(data,"****");

      // this.tableDataOut = data.list;
    },
    // 确定按钮(新增通到)
    async submitForm(formName) {
      let channel = JSON.stringify(this.tableData);
      // console.log(channel);

      let gateway_uuid = this.gatewayuuid;
      let { number, startaddress } = this.ruleForm;
      let flag = "add";
      const { code, data, msg } = await channelAdd(
        gateway_uuid,
        channel,
        flag,
        number,
        startaddress
      );

      if (code) {
        this.listwgtd();
        this.hunHeData();
        this.$message.success(msg);
        this.dialogVisibleDetile = false;
        return;
      }
      this.$message.error(msg);

      // console.log(this.ruleForm);
      // let objs = this.ruleForm;
      // // console.log(this.tableData);
      // objs.channelinfo = this.tableData;

      // this.$refs[formName].validate(async (valid) => {
      //   if (valid) {
      //     let frData = this.ruleForm;
      //     frData.gateway_uuid = this.gatewayuuid;
      //     const { code, data, msg } = await PropertyData(frData);
      //     // console.log(data);
      //     if (code) {
      //       let { property_uuid } = data;
      //       this.property_uuid = property_uuid;
      //       this.deterMine(); //网关参数请求
      //       // this.hunHeData()
      //       this.$message.success(msg);
      //       // this.dialogVisibleDetile = true;
      //     } else {
      //       this.$message.error(msg);
      //     }

      //     this.dialogVisibleDetile = false;
      //     //  this.hunHeData()
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    // 确定按钮(修改)
    async submitFormEdit(formName) {
      // console.log(this.tableData);
      // let { number, startaddress } = this.ruleForm;
      // console.log(number, startaddress);

      let channel = JSON.stringify(this.tableData);
      let gateway_uuid = this.gatewayuuid;
      let { number, startaddress, deviceid } = this.ruleForm;
      console.log(deviceid);

      let flag = "edit";
      const { code, data, msg } = await channelAdd(
        gateway_uuid,
        channel,
        flag,
        number,
        startaddress,
        this.property_uuid,
        deviceid
      );

      if (code) {
        this.listwgtd();
        this.hunHeData();

        this.$message.success(msg);
        this.ruleForm = {};
        //  this.ruleForm.number = '0001'
        // this.ruleForm.startaddress ='0000'
        this.dialogVisibleDetile = false;
        return;
      }
      this.$message.error(msg);

      // let objs = this.ruleForm;
      // // console.log(this.tableData);
      // objs.channelinfo = this.tableData;

      // this.$refs[formName].validate(async (valid) => {
      //   if (valid) {
      //     let frData = this.ruleForm;
      //     frData.gateway_uuid = this.gatewayuuid;
      //     const { code, data, msg } = await PropertyData(frData);
      //     // console.log(data);
      //     if (code) {
      //       let { property_uuid } = data;
      //       this.property_uuid = property_uuid;
      //       this.deterMineEdit(); //网关参数请求
      //       // this.hunHeData()
      //       this.$message.success(msg);
      //       // this.dialogVisibleDetile = true;
      //     } else {
      //       this.$message.error(msg);
      //     }

      //     this.dialogVisibleDetile = false;
      //     //  this.hunHeData()
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    // 修改的确定按钮
    async deterMineEdit() {
      this.dialogVisible = true;
      let channel = JSON.stringify(this.tableData);
      console.log(channel);

      let gateway_uuid = this.gatewayuuid;
      let property_uuid = this.property_uuid;
      let flag = "edit";
      const { code, data, msg } = await channelAdd(
        property_uuid,
        gateway_uuid,
        channel,
        flag
      );
      // console.log(data);
      if (code) {
        this.listwgtd();
        this.hunHeData();
      } else {
      }
    },
    // 通道参数确定按钮
    async deterMine() {
      this.dialogVisible = true;
      let channel = JSON.stringify(this.tableData);
      console.log(channel);

      let gateway_uuid = this.gatewayuuid;
      let property_uuid = this.property_uuid;
      let flag = "add";
      const { code, data, msg } = await channelAdd(
        property_uuid,
        gateway_uuid,
        channel,
        flag
      );
      console.log(data);
      if (code) {
        this.listwgtd();
        this.hunHeData();
      } else {
      }
    },
    dialogVisiblecs(formName) {
      // console.log("11")
      this.hunHeData();
      this.ruleForm = {};
      //  console.log(    this.ruleForm)
      this.tableData = [];
      this.dialogVisibleDetile = false;

      // this.$refs[formName].resetFields();
    },
  },
};
</script>

<style>
.params .el-table .success-row,
.el-table .success-row1 {
  height: 52px !important;
}
.params .el-icon-arrow-right:before {
  font-size: 17px;
}
.params .el-icon-arrow-right:hover {
  color: red;
  /* font-size: 17px; */
}
.params .el-table td {
  border-bottom: 1px solid #5cb6d9 !important;
}
/* .tablengt .el-table td, .el-table th.is-leaf{
  border-bottom: 1px solid #5cb6d9;
  
}
.tablengt .el-table td, .el-table th.is-leaf{
   border-bottom: 1px solid #5cb6d9 !important;
} */
.params {
  height: 100%;
  /* overflow: auto; */
}
.fromData {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.box_warpNet {
  display: flex;
  background: #5cb6d9;
  height: 35px;
  align-items: center;
  color: #ffffff;
  padding: 0 10px;
  /* font-size: 15px; */
}
.box_warpNet p {
  padding: 0 4px;
}
.box_warpNet > button {
  margin: 0 2px;
  /* height: 30px; */
  height: 26px !important;
}
.box_warpNet > .el-button + .el-button {
  margin-left: 4px !important;
  height: 26px !important;
}
.tale {
  padding: 15px 0;
  /* display: flex; */
}
.tale p {
  height: 22px;
  /* font-size: 18px; */
  font-weight: 400;
}
.input {
  display: flex;
}
</style>
